export default __webpack_public_path__ + "static/media/lifesatisfaction3Img1.a1abe800.png";